<div class="qr-tests-page">
  <section class="header">
    <div>
      <p class="eyebrow">QR generator</p>
      <h1>QR generator test page</h1>
      <p class="hint">Browser-side QR generation test using angularx-qrcode.</p>
    </div>
    <span class="pill" [ngClass]="status">{{ status }}</span>
  </section>

  <section class="workspace">
    <div class="controls">
      <label>
        <span>Type</span>
        <select [(ngModel)]="qrType" (ngModelChange)="onQRTypeChange()">
          <option value="url">URL</option>
          <option value="phone">Phone</option>
          <option value="message">Messaging</option>
        </select>
      </label>

      <label>
        <span>{{ qrValueLabel }}</span>
        <textarea [(ngModel)]="qrValue" rows="4" [placeholder]="qrValuePlaceholder"></textarea>
      </label>

      <label *ngIf="qrType === 'message'">
        <span>Message</span>
        <textarea [(ngModel)]="messageBody" rows="4" placeholder="Message body"></textarea>
      </label>

      <div class="control-grid">
        <label>
          <span>Size</span>
          <input type="number" [(ngModel)]="qrSize" min="100" step="50" />
        </label>

        <label>
          <span>Error correction</span>
          <select [(ngModel)]="errorCorrectionLevel">
            <option value="L">L</option>
            <option value="M">M</option>
            <option value="Q">Q</option>
            <option value="H">H</option>
          </select>
        </label>
      </div>

      <div class="actions">
        <button mat-flat-button color="primary" (click)="generateQRCode()">Generate QR</button>
        <a
          mat-stroked-button
          color="primary"
          *ngIf="qrCodeDownloadUrl"
          [href]="qrCodeDownloadUrl"
          download="qr-code.png">
          Download PNG
        </a>
      </div>

      <p class="message">{{ message }}</p>
    </div>

    <div class="preview">
      <div class="qr-frame" [style.max-width.px]="qrRenderSize">
        <ng-container *ngIf="generatedValue; else emptyPreview">
          <qrcode
            [qrdata]="generatedValue"
            [width]="qrRenderSize"
            [errorCorrectionLevel]="errorCorrectionLevel"
            [elementType]="'canvas'"
            [margin]="2"
            [ariaLabel]="'Generated QR code for ' + generatedValue"
            (qrCodeURL)="onQRCodeURL($event)">
          </qrcode>
        </ng-container>
        <ng-template #emptyPreview>
          <mat-icon>qr_code_2</mat-icon>
          <span>QR preview placeholder</span>
        </ng-template>
      </div>
      <p class="preview-value" *ngIf="generatedValue">{{ generatedValue }}</p>
    </div>
  </section>
</div>
